import type { ColorLabel as OldColorLabel } from "common/constants/colorsOld";
import oldColors from "common/constants/colorsOld";
import type { CSSProperties } from "react";
import React from "react";
import type { ColorLabel } from "ui/styles/colors";
import colors from "ui/styles/colors";

function getCompatibleThemeColor(color?: string): string | undefined {
  return colors[color as ColorLabel] ?? oldColors[color as OldColorLabel] ?? undefined;
}

export interface SvgIconProps extends React.SVGAttributes<SVGElement> {
  size?: number;
  color?: ColorLabel | OldColorLabel | string;
  backgroundColor?: ColorLabel | OldColorLabel | string;
  width?: number | string;
  height?: number | string;
  rotate?: number;
  title?: string;
  disabled?: boolean;
}

const defaultIconSize = 12;

export default function SVGIcon({
  children,
  size,
  width,
  height,
  rotate,
  color,
  backgroundColor,
  style,
  onClick,
  disabled,
  className,
  ...props
}: SvgIconProps) {
  const iconWidth = size ?? width ?? defaultIconSize;
  const iconHeight = size ?? height ?? defaultIconSize;

  const iconStyle: CSSProperties = {
    ...(style ?? {}),
    transform: rotate ? `rotate(${rotate}deg)` : style?.transform,
    cursor: onClick ? "pointer" : style?.cursor ?? "inherit",
    color: getCompatibleThemeColor(color) ?? style?.color,
    backgroundColor: getCompatibleThemeColor(backgroundColor),
    visibility: disabled ? "hidden" : undefined,
  };

  return (
    <svg width={iconWidth} height={iconHeight} style={iconStyle} onClick={onClick} className={className} {...props}>
      {children}
    </svg>
  );
}
